import { queryOptions, useQuery } from '@tanstack/react-query';

import { NodeSelectionTemplateSummary } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

const SELECTION_TEMPLATES_QUERY_KEY = 'autoscaler-selection-templates';

export const getSelectionTemplatesQueryKey = (clusterId?: string) =>
  clusterId
    ? ([SELECTION_TEMPLATES_QUERY_KEY, clusterId] as const)
    : ([SELECTION_TEMPLATES_QUERY_KEY] as const);

const getSelectionTemplatesQueryOptions = ({
  clusterId,
  enabled = true,
}: {
  clusterId: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getSelectionTemplatesQueryKey(clusterId),
    queryFn: async () => {
      const {
        data: { items },
      } = await apiClient.autoscaler.getSelectionTemplates({
        clusterId,
        includeDefault: true,
      });
      return items;
    },
    enabled: enabled && !!clusterId,
  });

type UseSelectionTemplatesQuery = {
  isLoading: boolean;
  selectionTemplates?: NodeSelectionTemplateSummary[];
  error: unknown;
  refetch: () => void;
};

export const useSelectionTemplatesQuery = ({
  clusterId,
  enabled = true,
}: {
  clusterId: string;
  enabled?: boolean;
}): UseSelectionTemplatesQuery => {
  const {
    isLoading,
    data: selectionTemplates,
    error,
    refetch,
  } = useQuery(getSelectionTemplatesQueryOptions({ clusterId, enabled }));

  return {
    isLoading,
    selectionTemplates,
    error,
    refetch,
  };
};
